// src/components/pages/CuestionariosCursos.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { getQuestionnaireCourses } from "../Stores/quizzesStore";

const CuestionariosCursos = () => {
  const navigate = useNavigate();
  const cursos = getQuestionnaireCourses();

  return (
    <div className="q-page">
      <div className="profile-header-title">
        <h1>Cuestionarios</h1>
        <p className="q-subtitle">
          Selecciona un curso para ver sus cuestionarios por módulo.
        </p>
      </div>

      <div className="q-courses-grid">
        {cursos.map((c) => (
          <div
            key={c.id}
            className="q-course-card"
            onClick={() => navigate(`/menu/lms/cuestionarios/${c.id}`)}
          >
            <div className="q-course-card-header">
              <h2 className="q-course-title">{c.titulo}</h2>
              <span className="q-course-status">{c.estado}</span>
            </div>
            <p className="q-course-summary">{c.resumen}</p>
            <div className="q-course-meta">
              <span>{c.totalModulos} módulos</span>
              <span>{c.totalCuestionarios} cuestionarios</span>
            </div>
            <button
              type="button"
              className="q-btn q-btn-primary q-course-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/menu/lms/cuestionarios/${c.id}`);
              }}
            >
              Ver cuestionarios
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CuestionariosCursos;
